import { useI18n } from "@wordpress/react-i18n";
import React, { useEffect, useId, useState } from "react";
export function ForminatorUpload(props) {
    const { __ } = useI18n();
    const [inputRef, setInputRef] = useState();
    const { value, onChange, filetypes, filesize, setErrors, id, } = props;
    const fileType = String(props['file-type']);
    const multiple = fileType == 'multiple' ? true : false;
    let maxFileSize = parseInt(props['upload-limit']);
    const fsMultiplyer = filesize === 'MB' ? 1024 * 1024 : filesize === 'KB' ? 1024 : 1;
    maxFileSize *= fsMultiplyer;
    const handleFileInput = (e) => {
        const files = Array.from(e.target.files || []);
        if (!files.length)
            return;
        // Validate each file
        for (const file of files) {
            if (file.size > maxFileSize) {
                setErrors((prev) => (Object.assign(Object.assign({}, prev), { [id]: `${__("Failo dydis negali viršyti", "ltg-widgets")} ${props["upload-limit"]}${filesize}` })));
                e.target.value = "";
                return;
            }
        }
        // Return either one file or all files depending on the "multiple" prop
        if (multiple) {
            onChange(files);
        }
        else {
            onChange(files[0]);
        }
    };
    const mime_types = filetypes || [];
    const mime_types_parsed = mime_types
        .reduce((agr, type) => type.indexOf('all-') === 0 ?
        agr :
        [...agr, '.' + type], [])
        .join(',')
        .replace(/\|/g, ',.');
    const htmlFor = useId();
    useEffect(() => {
        if (inputRef)
            inputRef.value = '';
    }, [value]);
    return React.createElement("div", { className: "ltg-forminator-field-upload" },
        React.createElement("input", { ref: setInputRef, type: 'file', accept: mime_types_parsed, multiple: multiple, className: 'sr-only', id: htmlFor, onChange: handleFileInput }),
        React.createElement("label", { className: 'btn', htmlFor: htmlFor }, __('Įkelti', 'ltg-widgets')),
        value && (multiple ? (
        // MULTIPLE FILES
        Array.isArray(value) && value.map((file, index) => (React.createElement("div", { key: index, className: "ltg-control ltg-forminator-field-upload-item" },
            React.createElement("span", null, file.name),
            React.createElement("button", null,
                React.createElement("i", { className: "fas fa-times text-danger", onClick: () => {
                        const newFiles = value.filter((_, i) => i !== index);
                        onChange(newFiles.length ? newFiles : undefined);
                    } })))))) : (
        // SINGLE FILE
        !Array.isArray(value) && (React.createElement("div", { className: "ltg-control ltg-forminator-field-upload-item" },
            React.createElement("span", null, value.name),
            React.createElement("button", null,
                React.createElement("i", { className: "fas fa-times text-danger", onClick: () => onChange(undefined) })))))));
}
